//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AttendanceStatus } from './Enums';

export class AttendanceMakeupCreditIssueSearchOptions extends ItemBase {
    AttendanceIDs: string[] = [];
    Status: AttendanceStatus = AttendanceStatus.Unrecorded;

    constructor(initializer?: Partial<AttendanceMakeupCreditIssueSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceMakeupCreditIssueSearchOptions";
}
